module.exports = __webpack_public_path__ + "img/Zoox_Pay.d6ee4220.png";